<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show.sync="show"
  >
    <CSidebarBrand>
    <CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        width="46" 
        height="46"
        src="img/brand/spannrit-logo.png"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        width="46" 
        height="46"
        src="img/brand/spannrit-logo.png"
      />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="getNav"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>

import navall from './_nav';
import navrasbery from './_navrasbery';


import { mapGetters, mapActions } from "vuex";

export default {
  name: 'TheSidebar',
  data () {
    return {
      minimize: false,
      
      navall,
      navrasbery,
      show: 'responsive'
    }
  },
  computed : {
    ...mapGetters(["isLoading","profile"]),
      getNav () {
        let ret = navrasbery;


        if ( this.profile.USER_APPROVE_RIGHT && this.profile.USER_HISTORY_RIGHT ) {
          ret = navall ;
        }


        
        return ret;
      }
  },
  mounted () {
    this.$root.$on('toggle-sidebar', () => {
      const sidebarOpened = this.show === true || this.show === 'responsive'
      this.show = sidebarOpened ? false : 'responsive'
    })
    this.$root.$on('toggle-sidebar-mobile', () => {
      const sidebarClosed = this.show === 'responsive' || this.show === false
      this.show = sidebarClosed ? true : 'responsive'
    })
  }
}
</script>
